import { Button, Container, Flex, Image, Text, Title } from "@mantine/core";
import logo from "../assets/logo-02.svg";

const NotReady = () => {
  return (
    <Container size="md">
      <Flex
        direction="column"
        align="center"
        justify="center"
        h="100vh"
        gap="md"
      >
        <Image
          src={logo}
          alt="Congrs Logo"
          style={{ maxWidth: "250px" }}
          mb="md"
        />

        <Flex direction="column" align="center" gap="md">
          <Title order={2} ta="center">
            This event is currently in preparation.
          </Title>

          <Text size="lg" c="dimmed" ta="center" maw={520}>
            Check back soon for more details.
          </Text>
        </Flex>

        <Flex gap="md">
          <Button
            size="md"
            variant="outline"
            onClick={() => window.location.reload()}
          >
            Try again
          </Button>
        </Flex>
      </Flex>
    </Container>
  );
};

export default NotReady;
